import { Box } from '@wix/design-system';
import { RuleGroupList, SectionDivider } from '@wix/rules-panel-ui';
import React from 'react';
import { SITE_LEVEL_PAGE_ID } from '../consts';
export const renderDividedRuleLists = _ref => {
  let {
    ruleGroups,
    pagesData,
    softIssueListSurfaces,
    nodeRef
  } = _ref;
  const groupsBySectionTitle = new Map();
  let siteLevelGroup;
  for (const group of ruleGroups) {
    var _pagesData$get;
    if (group.groupId === SITE_LEVEL_PAGE_ID) {
      siteLevelGroup = group;
      continue;
    }
    const groupSectionTitle = (_pagesData$get = pagesData.get(group.groupId)) == null ? void 0 : _pagesData$get.dividerTitle;
    if (groupSectionTitle) {
      const groups = groupsBySectionTitle.get(groupSectionTitle) ?? [];
      groups.push(group);
      groupsBySectionTitle.set(groupSectionTitle, groups);
    }
  }
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical"
  }, siteLevelGroup && /*#__PURE__*/React.createElement(RuleGroupList, {
    hideShadow: softIssueListSurfaces,
    parentNodeRef: nodeRef,
    ruleGroups: [siteLevelGroup]
  }), [...groupsBySectionTitle.entries()].map(_ref2 => {
    let [sectionTitle, groups] = _ref2;
    return /*#__PURE__*/React.createElement(Box, {
      direction: "vertical",
      key: sectionTitle
    }, /*#__PURE__*/React.createElement(SectionDivider, {
      backgroundColor: softIssueListSurfaces ? 'D70' : 'D60',
      title: sectionTitle
    }), /*#__PURE__*/React.createElement(RuleGroupList, {
      hideShadow: softIssueListSurfaces,
      parentNodeRef: nodeRef,
      ruleGroups: groups
    }));
  }));
};
//# sourceMappingURL=build-divided-group-component.js.map